module.exports = __webpack_public_path__ + "img/analise.1111aef5.svg";